export default [
  {
    link: 'dashboard',
    label: '待处理事项',
    visible:true,
    hideIcyDesign: true,
    tabId:0,
    icon: 'fa-tachometer'
  },
  {
    label: '第三方商品',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    hideIcyDesign: true,
    tabId:40,
    oldLink: true,
    subMenu: [
      {
        link: '/adminv/#!/thirdGoods/goodsList',
        label: '全部商品'
      },
      {
        link: 'handleGoods',
        label: '待处理商品',
        newLink: true,
      },
      {
        link: 'taobaoShopManager',
        label: '淘宝店铺管理',
        newLink: true,
      },
      {
        link: '/adminv/#!/thirdGoods/thirdBusinessList',
        label: '穿衣店铺管理'
      },
      {
        link: '/adminv/#!/thirdGoods/orderList',
        label: '订单列表'
      },
      {
        link: '/adminv/#!/thirdGoods/refundList',
        label: '退款退货列表'
      },
      {
        link: '/adminv/#!/thirdGoods/taobaoke',
        label: '淘客数据导入'
      }
    ]
  },

  {
    label: '高佣金商品',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    hideIcyDesign: true,
    tabId:44,
    oldLink: true,
    subMenu: [
      {
        link: '/adminv/#!/commissionGoods/goodsPool',
        label: '商品'
      },
      {
        link: '/adminv/#!/commissionGoods/goodsCollection',
        label: '商品集'
      },
      {
        link: '/adminv/#!/commissionGoods/adList',
        label: '广告位'
      },
      {
        link: '/adminv/#!/commissionGoods/commissionGoodsHistory',
        label: '佣金商品记录'
      },
      {
        link: '/adminv/#!/commissionGoods/businessImportHistory',
        label: '商家导入记录'
      }
    ]
  },
  {
    label: '客服',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    tabId:40,
    subMenu: [
      {
        link: 'thirdpartnarChatConf',
        label: '代运营对话配置'
      },
    ]
  },
  {
    label: '视频管理',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    tabId:41,
    oldLink: true,
    subMenu: [
      {
        link: '/adminv/#!/videoUploader',
        label: '视频上传'
      }
    ]
  },
  {
    label: '第三方搭配',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    hideIcyDesign: true,
    tabId:40,
    oldLink: true,
    subMenu: [
      {
        link: '/adminv/#!/thirdSuit/thirdPendingSuit',
        label: '待审核第三方搭配'
      },
      {
        link: '/adminv/#!/thirdSuit/thirdSuitList',
        label: '第三方搭配列表'
      },
      {
        link: '/adminv/#!/thirdSuit/keywordManage',
        label: '关键词管理'
      }
    ]
  },
  {
    label: '自主商品',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    tabId:40,
    subMenu: [
      {
        link: 'showTimeLimit',
        label: '限时折扣'
      }
    ]
  },
  {
    label: '微信公众号管理',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    hideIcyDesign: true,
    tabId:45,
    subMenu: [
      {
        link: 'subscriptionsSearch',
        label: '最近更新列表'
      },
      {
        link: 'subscriptionsManage',
        label: '公众号管理'
      },
      {
        link: 'subscriptionsAdd',
        label: '添加公众号'
      }
    ]
  },
  {
    label: '活动',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    tabId:40,
    subMenu: [
      {
        link: 'showTimeLimitPrice',
        label: '限时改价'
      },
      {
        link: 'specialAdvertisement',
        label: '活动特殊广告'
      },
      {
        link: 'priceTag',
        label: '价格标签'
      },
      {
          link: 'addCartPrize',
          label: '加购物车得奖'
      },
      {
          link: 'zys',
          label: '张一山分享活动'
      },
      {
          link: 'collectionList',
          label: '小程序单品合集页'
      },
      {
        link: 'couponsPop',
        label: '小程序优惠券弹窗'
      },
      {
        link: 'miniAppAdv',
        label: '小程序广告设置'
      },
      {
      link: 'miniGoodsQrcode',
      label: '小程序码下载'
      }
    ]
  },
  {
    label: '穿衣-首页',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    hideIcyDesign: true,
    tabId:40,
    subMenu: [
      {
        link: 'cyzsAdList',
        label: '链接广告位'
      },
      {

        link: 'cyzsIndexTopic',
        label: '专题广告位'
      },
      {
        link: 'channelList',
        label: '频道列表'
      },
      {
        link: 'cyzsIndexPopAd',
        label: '主页弹窗广告'
      },
      /*{
        link: 'votingSetting',
        label: '投票设置'
      }*/
    ]
  },
  {
    link: 'market',
    label: '市集',
    visible:true,
    hideIcyDesign: true,
    tabId:0,
    icon: 'fa-bar-chart'
  },
  {
    link: 'discovery',
    label: '发现',
    visible:true,
    hideIcyDesign: true,
    tabId:0,
    icon: 'fa-bar-chart'
  },
  {
    label: '我的',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    hideIcyDesign: true,
    tabId:40,
    subMenu: [
        {
            link: 'hotAd',
            label: '热区广告位'
        }
    ]
  },
  {
    label: '穿衣-专题管理',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    hideIcyDesign: true,
    tabId:40,
    subMenu: [
      {
        link: 'cyzsTopicList',
        label: '专题列表'
      },
      {
        link: 'topicCategorieList',
        label: '专题分类'
      }
    ]
  },
  {
    label: '穿衣-动态管理',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    hideIcyDesign: true,
    tabId:40,
    subMenu: [
      {
        link: 'articleList',
        label: '全部动态'
      },
      {
        link: 'cyzsIcon',
        label: 'ICON管理'
      },
      {
        link: 'tagManage',
        label: '标签管理'
      },
      {
        link: 'pictureAudit',
        label: '图片审核'
      },
      {
        link: 'similaryGoods',
        label: '相似商品列表'
      },
      {
        link: 'votingContentLibrary',
        label: '投票内容库'
      }
    ]
  },
  {
    label: '穿衣-内容源管理',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    hideIcyDesign: true,
    tabId:40,
    subMenu: [
      {
        link: 'contentPool',
        label: '内容池'
      },
      {
        link: 'subscripeSource',
        label: '订阅内容源'
      },
      {
          link: 'internetStarSource',
          label: '网红商品源'
      },
    ]
  },
  {
    label: '穿衣-系统设置',
    icon: 'fa-cog',
    expanded: false,
    visible: false,
    hideIcyDesign: true,
    tabId: 40,
    subMenu: [
      {
        link: 'specialAccount',
        label: '特殊账号配置'
      },
      {
        link: 'initialContent',
        label: '初始内容设置'
      },
      {
        link: 'operatingRecord',
        label: '操作日志'
      },
      {
        link: 'category',
        label: '识别类目'
      }
    ]
  },
  {
  	label: '推送',
  	icon: 'fa-cog',
  	expanded: false,
  	visible: false,
  	tabId: 11,
  	subMenu: [
  	  {
  		link: 'groupPush',
  		label: '穿衣小程序推送'
  	  },
  	]
  },

]
